<app-header></app-header>
<div class="d-flex w-100 supplearn webview">
  <h4 class="col-3 supphead semi-bold">Support & Learn</h4>
  <ul class="nav nav-tabs col-9">
    <li class="nav-item">
      <a class="nav-link active suppsubhead" href="javascript:void(0)" routerLink="/faq" id="faq">FAQ <i class="arrow" style="font-style:normal !important"></i></a>
    </li>
    <li class="nav-item">
      <a class="nav-link suppsubhead" href="javascript:void(0)"  id="contact-us" routerLink = "/faq/contact-us" >Contact Us <i class="arrow" style="font-style:normal !important"></i></a>
    </li>
    <li class="nav-item">
      <a class="nav-link suppsubhead" href="javascript:void(0)"  id="privacy-policy" routerLink = "/faq/privacy-policy" >Privacy Policy <i class="arrow" style="font-style:normal !important"></i></a>
    </li>
    <li class="nav-item">
      <a class="nav-link suppsubhead" href="javascript:void(0)"  id="terms-of-service" routerLink = "/faq/terms-of-service" >Terms of Service <i class="arrow" style="font-style:normal !important"></i></a>
    </li>
  </ul>
</div>
<div *ngIf="type === 'faq'" id="faq">
  <app-faq></app-faq>
</div>
<div *ngIf="type === 'contact-us'" id="contact-us">
   <app-pre-contact [contVisible]="contactVisible"></app-pre-contact> 
</div>
<div *ngIf="type === 'privacy-policy'" id="privacy-policy">
  <app-privacy-policy [privVisible]="privacyVisible"></app-privacy-policy>
</div>
<div *ngIf="type === 'terms-of-service'" id="terms-of-service">
  <app-terms-of-service [termVisible]="termsVisible"></app-terms-of-service>
</div>
<app-footer></app-footer>